import { defineStore } from 'pinia'

const useTokenStore = defineStore('token', () => {
    const token = ref('')
    const tokenExpirationDate = ref<string | null>(null)
    const refreshToken = ref('')
    const refreshTokenExpirationDate = ref<string | null>(null)

    return {
        token,
        tokenExpirationDate,
        refreshToken,
        refreshTokenExpirationDate
    }
})

type TokenStore = Omit<
    ReturnType<typeof useTokenStore>,
    keyof ReturnType<typeof defineStore>
>

export default useTokenStore

export type { TokenStore }
